export default {
    timer: {
        title: 'Timer',
        durationLabel: 'Duration',
        intervalLabel: 'Interval',
        soundsLabel: 'Background sound',
        soundBeforeLabel: 'Greeting voice at the beginning',
        soundAfterLabel: 'Thanking voice at the end',
        sounds: [
            {
                name: 'No Sound',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/timer/images/Ear+Phones-min.jpg',
                sound: ''
            },
            {
                name: 'Theta',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/timer/images/Music_waves-04-min.jpg',
                sound:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/timer/sounds/465995-375Hz_5Hz_Theta_Waves_.mp3'
            },
            {
                name: 'Rain',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/timer/images/Water-min.jpg',
                sound:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/timer/sounds/rain.mp3'
            },
            {
                name: 'Waves',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/timer/images/WAVES-min.jpg',
                sound:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/timer/sounds/Aegean+sea+waves+breaking+on+the+beach+distant+perspective.mp3'
            },
            {
                name: 'Birds',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/timer/images/Himalayan+Birds-min.jpg',
                sound:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/timer/sounds/black-headed%2Bbulbul%2Bsong-%2Bthai%2B230703.mp3'
            },
            {
                name: 'Flute',
                image:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/timer/images/Forest--min.jpg',
                sound:
                    'https://s3.us-east-2.amazonaws.com/chillanywhere.com/timer/sounds/Xiao_Dm_Gm_Ph1.mp3'
            }
        ]
    }
};
